import React, { useEffect, useState } from "react";
import CustomButton from "../../components/AddButton/index";
import {
  vehicle,
  container,
  truck,
  edit,
  Plus,
  map,
  trips,
  booking,
} from "../../common/svg";
import CustomCard from "../../components/Card/index";
import { bookingDetails } from "../../common/staticData";
import DaysLeftCounter from "../../components/DaysProgress/index";
import CustomChip from "../../components/Chip";
import { images } from "../../common/tabs";
import DocumentUpload from "./view/components/Upload";
import Filter from "../../components/FilterButton";
import Notification from "../Notification";
import ReportButton from "../../components/ReportButton";
import Header from "../../components/Header/index";
import { useNavigate } from "react-router-dom";
import ClientViewPage from "./view/index";
import ShippingFlow from "../../components/TrackingStatus/Track";
import DateTimePicker from "../../components/Date&Time";
import TransportTracker from "./view/components/TransportTracker";
import DeliveryTimeline from "../../components/DeliveryTimeline";
import ExpenseList from "../Client/view/components/Expense Details";
import LiveStatus from "../Client/view/components/Livestatus";
import ContainerVehicleDetails from "../Client/view/components/container";
import BookingDetails from "../Client/view/components/Triptype";
import SecureImage from "../../components/BucketImage/Image";
import InfiniteScrollContainer from "../../components/InfiniteScroll/InfiniteScroll";
import { ApiService } from "../../service/api.service";
import { ECHO_URL, MASTER_URL, OPERTIONS_URL } from "../../common/common";
// OLD MAP COMPONENT - TEMPORARILY RE-ENABLED FOR TESTING
import SimpleLiveTrackingMap from "../../components/LiveTracking/LiveTrackingMap";
import moment from "moment";
import { useLiveTracking } from "../../hooks/useLiveTracking";

// NEW TRIP MAP COMPONENT - SIMPLIFIED VERSION
import SimpleTripMap from "../../components/TripMap/SimpleTripMap";

const Triplist = () => {
  const apiService = new ApiService();
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState(true);
  const entityId = localStorage.getItem("entity_id");
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [allTrips, setAllTrips] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isBlurred, setIsBlurred] = useState(true);
  const {
    showMap,
    hasTrackingData,
    isLoading,
    error,
    startTracking,
    setFirstDataReceived,
    canShowMap,
    isInLoadingState
  } = useLiveTracking();
  const [vehcileDetails, setVehcileDetails] = useState<any>([]);

  // NEW TRIP MAP STATE VARIABLES - TEMPORARILY COMMENTED OUT DUE TO IMPORT ERROR
  // const [tripMapData, setTripMapData] = useState<TripData | null>(null);
  // const [vehicleAssignments, setVehicleAssignments] = useState<VehicleAssignment[]>([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState<string | null>(null);

  const handleToggle = () => {
    setIsBlurred(!isBlurred);
  };

  const navigate = useNavigate();

  const handleTripClick = (id: any) => {
    navigate(`view/trip/${id}`);
  };

  const handleClick = () => {
    navigate("newtrip");
  };

  const handleViewTripDetails = (index: number) => {
    console.log("Trip ID:", allTrips[index].tripId);
    if (allTrips[index].tripId) {
      getTripById(allTrips[index].tripId);
    }
    setActiveTripCard(index);
    setViewTripDetails(true);
  };

  // NEW TRIP MAP HANDLERS - TEMPORARILY COMMENTED OUT DUE TO IMPORT ERROR
  /*
  const handleVehicleSelect = (vehicle: VehicleAssignment) => {
    console.log("🚗 Vehicle selected:", vehicle);
    setSelectedVehicleId(vehicle.vehicleId);
    // You can add additional logic here for vehicle selection
  };
  */

  const handleMapReady = () => {
    console.log("🗺️ Trip map is ready");
    // You can add additional logic here when map is ready
  };

  const fetchMoreData = async () => {
    if (!hasMore || isFetching) return;

    setIsFetching(true);

    try {
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/trip/get-all-route`
      );

      if (response?.status === "200") {
        const newBookings = response.body.data || [];
        const pagination = response.body.pagination;

        setAllTrips((prev: any[]) => [...prev, ...newBookings]);

        // Update pagination details
        setHasMore(pagination.hasNextPage);
        setTotalRecords(pagination.totalRecords);

        if (pagination.hasNextPage) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setHasMore(false);
    } finally {
      setIsFetching(false);
    }
  };

  const getTripById = async (id: string) => {
    try {
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/trip/details-route?tripId=${id}`
      );
      if (response?.status === "200") {
        console.log("Trip details:", response.body.data);
        let trip = response.body[0]?.vehicleAssignments || [];
        if (trip) {
          // Fetch vehicle details with tracking URL from master data service
          console.log("🔍 Original trip data:", trip);
          const enrichedTrip = await Promise.all(
            trip.map(async (assignment: any) => {
              console.log("🔍 Processing assignment:", assignment);
              if (assignment.vechicleData?.vehicleId) {
                console.log("🔍 Fetching vehicle details for vehicleId:", assignment.vechicleData.vehicleId);
                try {
                  const vehicleResponse: any = await apiService.getApi(
                    `${MASTER_URL}/vehicle/get-one-route?vehicleId=${assignment.vechicleData.vehicleId}`
                  );
                  console.log("🔍 Vehicle API response:", vehicleResponse);
                  if (vehicleResponse?.status === "200") {
                    console.log("🔍 Vehicle trackingUrl:", vehicleResponse.body.trackingUrl);
                    return {
                      ...assignment,
                      vechicleData: {
                        ...assignment.vechicleData,
                        trackingUrl: vehicleResponse.body.trackingUrl
                      }
                    };
                  }
                } catch (error) {
                  console.error("❌ Error fetching vehicle details:", error);
                }
              } else {
                console.log("⚠️ No vehicleId found in assignment:", assignment);
              }
              return assignment;
            })
          );
          console.log("🔍 Enriched trip data:", enrichedTrip);
          setVehcileDetails(enrichedTrip);
        }

        // NEW TRIP MAP DATA POPULATION - TEMPORARILY COMMENTED OUT DUE TO IMPORT ERROR
        /*
        const tripDetails = response.body[0] || {};
        
        // Set trip map data
        const tripMapData: TripData = {
          tripId: tripDetails.tripId || id,
          tripName: tripDetails.tripName || 'Trip',
          status: tripDetails.status || 'active',
          pickupLocation: {
            latitude: tripDetails.pickupLatitude || 0,
            longitude: tripDetails.pickupLongitude || 0,
            address: tripDetails.pickupAddress,
            city: tripDetails.pickupCity,
            state: tripDetails.pickupState,
            country: tripDetails.pickupCountry
          },
          deliveryLocation: {
            latitude: tripDetails.deliveryLatitude || 0,
            longitude: tripDetails.deliveryLongitude || 0,
            address: tripDetails.deliveryAddress,
            city: tripDetails.deliveryCity,
            state: tripDetails.deliveryState,
            country: tripDetails.deliveryCountry
          },
          startDate: tripDetails.startDate,
          endDate: tripDetails.endDate,
          route: tripDetails.route || []
        };
        setTripMapData(tripMapData);

        // Set vehicle assignments
        const vehicleAssignments: VehicleAssignment[] = (tripDetails.vehicleAssignments || []).map((assignment: any) => ({
          vehicleId: assignment.vehicleId || assignment.vechicleData?.vehicleId,
          vehicleRegNo: assignment.vechicleData?.vehicleRegNo || assignment.vehicleRegNo,
          vehicleType: assignment.vechicleData?.vehicleType || assignment.vehicleType,
          driverName: assignment.driverData?.driverName || assignment.driverName,
          driverContact: assignment.driverData?.driverContact || assignment.driverContact,
          status: assignment.status || 'assigned',
          currentLocation: assignment.currentLocation,
          trackingUrl: assignment.vechicleData?.trackingUrl || assignment.trackingUrl
        }));
        setVehicleAssignments(vehicleAssignments);

        console.log("🗺️ Trip map data populated:", { tripMapData, vehicleAssignments });
        */
      }
    } catch (error) {
      console.error("Error fetching trip details:", error);
    }
  };

  useEffect(() => {
    fetchMoreData();
  }, [entityId]);

  const ShowMap = async () => {
    try {
      // Always show the map - don't depend on vehicle registration number
      console.log("🗺️ Showing map with SimpleTripMap component");
      setIsBlurred(false);

      // Try to start tracking if we have vehicle registration number, but don't block map display
      const vehicleRegNo = vehcileDetails?.[0]?.vechicleData?.vehicleRegNo;
      if (vehicleRegNo) {
        console.log("🚗 Starting tracking for vehicle:", vehicleRegNo);
        await startTracking(vehicleRegNo);
      } else {
        console.log("⚠️ No vehicle registration number found, but showing map anyway");
      }
    } catch (error) {
      console.error("❌ Error starting live tracking:", error);
      // Still show the map even if tracking fails
      setIsBlurred(false);
    }
  };

  return (
    <div>
      <Header title="Trips" showSearch={false} icon={trips}>
        <div className="flex gap-2">
          <DateTimePicker />
          <Filter />
          <ReportButton />
          <CustomButton
            label=""
            icon={Plus}
            onClick={() => navigate("newtrip")}
          />
          <Notification />
        </div>
      </Header>
      <div>
        <ClientViewPage />
      </div>
      <div className="bg-white p-2 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#444FBD] text-[16px]  font-[600]">
            Trip Details ({totalRecords || 0})
          </p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 ">
          <InfiniteScrollContainer
            width="400px"
            fetchMoreData={fetchMoreData}
            hasMore={hasMore}
            isFetching={isFetching}
          >
            <div>
              {allTrips.map((trip, index) => (
                <CustomCard
                  key={index}
                  onClick={() => handleViewTripDetails(index)}
                  isActive={activeTripCard === index}
                  className="w-[350px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
                >
                  <div className="gap-[-1]">
                    <div className="flex justify-between items-center ">
                      <div className="flex items-center space-x-2">
                        <p className="font-semibold">
                          {trip.tripName}
                        </p>
                        <CustomChip
                          text={trip.bookingStatus || "Pending"}
                          textColor="#FF973C"
                          borderColor="#FF973C"
                        />
                      </div>
                      <p className=" font-[400] text-[14px]">#0{index + 1}</p>
                    </div>
                    <div className=" flex justify-between">
                      <div className="leading-[18px]">
                        <p className="text-[14px]">#{trip.tripNumber}</p>
                        <p className="text-[14px]  font-[400]">
                          {moment(trip.bookingDate).format("DD MMMM YYYY, hh:mma")}
                        </p>
                      </div>
                      <div className="flex items-center flex-col  justify-center">
                        <DaysLeftCounter
                          totalDays={trip.daysLeft}
                        />
                        <p className="text-[14px] font-[400]">Days left</p>
                      </div>
                    </div>
                    <div className="flex justify-between items-end">
                      <div className="flex flex-col leading-[15px]">
                        <p className="text-[14px]">Booking</p>
                        <button
                          className={`font-medium text-left text-[14px]  ${activeTripCard === index
                            ? "text-[#F7941D]"
                            : "text-[#444FBD]"
                            }`}
                          onClick={() => navigate(`/booking/view/${trip.bookingId}`)}
                        >
                          {trip.bookingName || "Client Name"}
                        </button>
                      </div>
                      <div className="leading-[15px]">
                        <p className="text-[14px] text-right text-[#F7941D] font-[300]">
                          Point
                        </p>
                        <p className="text-[16px] text-[#F7941D] font-[600]">
                          Clearance
                        </p>
                      </div>
                    </div>
                  </div>
                </CustomCard>
              ))}
            </div>
          </InfiniteScrollContainer>
          {viewTripDetails && activeTripCard !== null && (
            <div className="mt-[-20px] w-full border-l border-[#C1C1C1] border-dashed">
              <div className="flex flex-col w-full">
                <div className="flex justify-between w-full p-2">
                  <div className="flex items-center space-x-2 ">
                    <SecureImage
                      fileKey={truck}
                      alt="header icon"
                      width="89px"
                    />
                    <div>
                      <div className="flex items-center space-x-2 leading-[-15px]">
                        <p
                          className="text-[#444FBD] text-[14px] cursor-pointer font-[600]"
                          onClick={() => handleTripClick(allTrips[activeTripCard]?.tripId)}
                        >
                          {allTrips[activeTripCard]?.tripName}
                        </p>
                        <CustomChip
                          text="Waiting for clearance"
                          textColor="#FF973C"
                          backgroundColor="#FFF5EC"
                          borderColor="#FF973C"
                        />
                      </div>
                      <p className="text-[14px]  font-[400]">
                        {allTrips[activeTripCard]?.tripNumber}
                      </p>
                      <p className="text-[14px]  font-[400]">
                        {moment(allTrips[activeTripCard]?.startingDateTime).format("DD MMMM YYYY, hh:mma")}
                      </p>
                    </div>
                  </div>
                  {/* right */}
                  <div className="flex justify-end">
                    <div className="flex flex-col items-end  ">
                      <div className="flex items-center ">
                        <DaysLeftCounter
                          totalDays={allTrips[activeTripCard]?.daysLeft}
                        />
                        <p className="text-[14px] font-[400]">Days left</p>
                      </div>
                      <p className="text-[14px]  font-[400]">
                        {moment(allTrips[activeTripCard]?.endingDateTime).format("DD MMMM YYYY, hh:mma")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap text-center justify-center  gap-6 p-4 ">
                  <BookingDetails
                    id={allTrips[activeTripCard]?.tripId}
                  />
                </div>
                <br />
                <div className="mt-5 w-full max-w-4xl mx-auto px-4">
                  <TransportTracker />
                  <ShippingFlow />
                </div>
                <br />
                <LiveStatus />
                <br />
                <ContainerVehicleDetails
                  handleClick={handleClick}
                  container={container}
                  vehicle={vehicle}
                  images={images}
                  tripData={allTrips[activeTripCard]}
                  vehcileDetails={vehcileDetails}
                  companyDetail={vehcileDetails[0]?.companyDetail || {}}
                />
                <div className="p-2 flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <p className="text-[16px] font-[600] leading-[30px]">
                      Route Points
                    </p>
                    <CustomButton
                      label=""
                      icon={edit}
                      onClick={handleClick}
                    />
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="">
                      <DeliveryTimeline />
                    </div>
                    {/* Map - UPDATED WITH NEW TRIP MAP COMPONENT */}
                    <div className="w-[450px] h-[500px] rounded-[30px] mt-10 overflow-hidden relative">
                      {!isBlurred ? (
                        <div className="w-full h-full">
                          {/* NEW TRIP MAP COMPONENT - SIMPLIFIED VERSION */}
                          <SimpleTripMap
                            tripId={allTrips[activeTripCard]?.tripId}
                            showMap={true}
                            onMapReady={handleMapReady}
                            trackingUrl={vehcileDetails?.[0]?.vechicleData?.trackingUrl || vehcileDetails?.[0]?.trackingUrl}
                          />
                        </div>
                      ) : (
                        <div
                          className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-500 text-3xl font-semibold cursor-pointer"
                          onClick={ShowMap}
                        >
                          Show Map
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* Expense Details */}
                <div className="p-2 border-b border-[#C1C1C1] border-dashed">
                  <div className="flex justify-between items-center">
                    <p className="text-[16px] font-[600] text-[#282828] leading-[30px]">
                      Expense Details
                    </p>
                    <div className="flex gap-2">
                      <CustomButton
                        label=""
                        icon={edit}
                        onClick={handleClick}
                      />
                      <CustomButton
                        label=""
                        icon={Plus}
                        onClick={handleClick}
                      />
                    </div>
                  </div>
                  <ExpenseList />
                </div>
                <div>
                  <DocumentUpload />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Triplist;